export const FETCH_LAYOUTS_REQUEST = 'FETCH_LAYOUTS_REQUEST'
export const FETCH_LAYOUTS_SUCCESS = 'FETCH_LAYOUTS_SUCCESS'
export const FETCH_LAYOUTS_FAILURE = 'FETCH_LAYOUTS_FAILURE'
export const SET_LAYOUTS_FILTERS = 'SET_LAYOUTS_FILTERS'
export const SET_LAYOUTS_ITEMS = 'SET_LAYOUTS_ITEMS'
export const RESET_LAYOUTS_FILTER = 'RESET_LAYOUTS_FILTER'
export const SET_ALL_FILTERS = 'SET_ALL_FILTERS'
